import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import { TextInlineEditRSA } from '@bingads-webui-campaign/asset-inline-edit';
import template from './text.pug';

export class ColumnAsset extends CampaignuiBaseColumn {
  constructor({
    i18n, view, scope, serverContext, permissions,
  }) {
    const title = i18n.getString('ColumnName_Asset');
    const adType = scope && scope.values && scope.values.adType;

    super({
      name: 'Asset',
      property: 'Asset/Text',
      sortable: 'Asset/Text',
      title,
      type: 'string',
      enableEdit: item => item.Asset.AssetType === 'Text' && item.Asset.AssetSource === 'AdvertiserProvided' && item.UiDisplayStatus === 'Active' && adType === 'ResponsiveSearch',
      bodyClasses: 'grid-column-Asset',
      helpId: 'pop_BA_RSA_Asset',
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: title }),
    });
    this.i18n = i18n;
    this.view = view;
    this.scope = scope;
    this.serverContext = serverContext;
    this.permissions = permissions;
  }

  get property() {
    return {
      get: ({
        Asset,
      }) => Asset.Text,
    };
  }

  template({ value }) {
    return template({
      text: value,
    });
  }

  onPrompt({
    item, newPosition,
  }) {
    return TextInlineEditRSA({
      item,
      newPosition,
      view: this.view,
      i18n: this.i18n,
      scope: this.scope,
      itemToSchemaMap: {
        Headlines: 'Headline',
        Descriptions: 'Description',
      },
      schemaToItemMap: {
        Headline: 'Headlines',
        Description: 'Descriptions',
      },
      serverContext: this.serverContext,
      permissions: this.permissions,
    });
  }
}
